module.exports = __webpack_public_path__ + "img/truck.6dcd9eb0.svg";